<script setup lang="ts">
import { useExternalLinksStore } from "@/stores";
import Button from "@/components/general/Button/Button.vue";

const externalLinks = useExternalLinksStore();

const emit = defineEmits(["t&c", "on-continue"]);
</script>

<template>
    <h3 class="boc-title"> By proceeding I confirm: </h3>
    <div class="white-box grey-border">
        <ul>
            <li>
                That I am a UK resident and that I reside in the UK for at least
                183 days a year.
            </li>
            <li>That the information I have provided is accurate; and</li>
            <li>
                That I have seen and read the
                <a
                    :href="externalLinks.policySummary"
                    target="blank"
                    @click="emit('t&c')"
                >
                    Policy Summary</a
                >,
                <a
                    :href="externalLinks.termsAndConditions"
                    target="blank"
                    @click="emit('t&c')"
                >
                    Terms & Conditions</a
                >
                and
                <a
                    :href="externalLinks.demandsAndNeeds"
                    target="blank"
                    @click="emit('t&c')"
                >
                    Demands & Needs</a
                >.
            </li>
            <li>
                The personal information we have collected from you will be
                shared with fraud prevention agencies who will use it to prevent
                fraud and money-laundering and to verify your identity. If fraud
                is detected, you could be refused certain services, finance, or
                employment. Further details of how your information will be used
                by us and these fraud prevention agencies, and your data
                protection rights, can be found by accessing this link,
                <a :href="externalLinks.fairProcessingNotice" target="blank">
                    www.cifas.org.uk/fpn</a
                >.
            </li>
        </ul>
    </div>
    <div>
        <p class="confirm-warning">
            By clicking the button below you are confirming the above.
        </p>
        <div class="actions">
            <Button
                id="buy-policy"
                btn-type="primary"
                class="continue"
                @click.once.prevent="emit('on-continue')"
            >
                Buy Now
            </Button>
        </div>
    </div>
</template>

<style scoped>
.boc-title {
    margin: 0.25rem 0;
    font-weight: normal;
    font-size: 20px;
    color: var(--off-black);
}

.white-box {
    background: var(--pure-white);
    margin-bottom: 1rem;
    padding: 1rem;
}

.grey-border {
    border: 1px solid var(--grey-warm);
}

.confirm-warning {
    font-weight: 700;
}

.continue {
    margin-top: 1rem;
}
</style>
